import {
  PairedSalesAnalysisFeature,
  PairedSalesCustomAnalysisFeature,
  isObject,
  isString,
} from '@aloft/toolkit-shared';

export const isPairedSalesCustomAnalysisFeature = (
  x: PairedSalesAnalysisFeature,
): x is PairedSalesCustomAnalysisFeature => !isString(x) && isObject(x) && 't' in x && 'name' in x;
